import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import DriverView from "./pages/DriverView";
import SharePage from "./pages/SharePage";
import InstallPrompt from "./components/InstallPrompt";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";
// Import api.js early to setup axios interceptor
import "./utils/api";

// Protected route component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Role-based dashboard
function Dashboard() {
  const { isAdmin, isDriver } = useAuth();
  
  if (isAdmin) {
    return <AdminDashboard />;
  }
  
  if (isDriver) {
    return <DriverView />;
  }
  
  return <Navigate to="/login" replace />;
}

// Login route - redirect if already authenticated
function LoginRoute() {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return <Login />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/s/:shareId" element={<SharePage />} />
      <Route path="/share/:shareId" element={<SharePage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="bottom-center" />
        <InstallPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
